import { Component, EventEmitter, Input, OnInit, Output} from '@angular/core';

import * as Objects from '@core/objects';

@Component({
    selector: 'core-labels-list',
    templateUrl: './labels-list.component.html',
    styleUrls: ['./labels-list.component.scss'],
    providers: []
})
export class LabelsListComponent implements OnInit{
    @Input() labels: Array<Objects.Label>;
    @Output() choose  = new EventEmitter<Objects.Label>();
    public isChooseObserved: boolean = false;
    
    constructor(){}

    ngOnInit(): void {
        this.isChooseObserved = this.choose.observed;
    }

    action(label: Objects.Label) {
        this.choose.emit(label);
    }
}
